(function () {
  var _fetch = window.fetch;

  function getReserveTime() {
    var btn = document.getElementById('StickyAddToCartButton');
    if (btn && btn.dataset && btn.dataset.reserveTime) return String(btn.dataset.reserveTime).trim();

    var sel = document.getElementById('StickyVariantSelect');
    if (sel && sel.selectedIndex >= 0) {
      var opt = sel.options[sel.selectedIndex];
      if (opt && opt.dataset && opt.dataset.reserveTime) return String(opt.dataset.reserveTime).trim();
    }
    return '';
  }

  function inject(bodyStr) {
    var t = getReserveTime();
    if (!t) return bodyStr;

    var d;
    try { d = JSON.parse(bodyStr); } catch (e) { return bodyStr; }
    if (!d || !Array.isArray(d.items)) return bodyStr;

    d.items.forEach(function (it) {
      if (!it || typeof it !== 'object') return;
      it.properties = it.properties || {};
      it.properties['予約'] = t;
    });

    return JSON.stringify(d);
  }

  if (_fetch) {
    window.fetch = function (input, init) {
      try {
        var url = (typeof input === 'string') ? input : (input && input.url) ? input.url : '';
        var method = (init && init.method ? init.method : 'GET').toUpperCase();

        if (method === 'POST' && url && url.indexOf('/cart/add.js') !== -1 && init && typeof init.body === 'string') {
          init.body = inject(init.body);
        }
      } catch (e) {}

      return _fetch.apply(this, arguments);
    };
  }
})();